import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '../../features/user-management/services/user.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const api = environment.dataLensAPI;
  if (!api || !req.url.includes(api)) {
    return next(req);
  }
  const token = inject(UserService).accessToken();
  if (!token) {
    return next(req);
  }
  return next(
    req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token),
    }),
  );
};
